import { Drawer, Grid } from "@mui/material";
import { useEffect, useState } from "react";
import { ValidatorForm } from "react-material-ui-form-validator";
import { PrimaryButton } from "../../_components/button/primary.button";
import { DrawerHeader } from "../../_components/drawer/header.drawer";
import { TextValidatorHcs } from "../../_components/textValidator/textValidatorHcs";
import { toastr } from "../../_components/toastr/toastr";
import { handleErrorResponse } from "../../_helpers/handleResponse.helper";
import { useDrawerStyles } from "../../_styles/drawer.styles";
import moment from "moment";
import { emailtemplateService } from "../../_services/emailTemplate.service";
import { EmailTypeEnum } from "../../_common/enum/emailType.enum";
import { getEnumDropdown } from "../../_helpers/form.helper";
import { TinyMce } from "../tinyMce/tinyMce";

export const EmailTemplateManageDrawer = (params: { isOpen: boolean, itemId: number | null, onSave(): void, onClose(): void }) => {

    const resetData = () => ({
        id: 0,
        name: "",
        value: 0,
        code: "",
        startDate: "",
        expiryDate: ""
    });

    const [data, setData] = useState<any>(resetData);

    useEffect(() => {
        if (params.itemId != null)
            fetchData();
        else
            setData(resetData);
    }, [params.itemId, params.isOpen]);

    const [isLoading, setIsLoading] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    function fetchData() {
        if (!params.itemId) return;

        setIsLoading(true)
        return emailtemplateService
            .get(params.itemId)
            .then(
                (json) => {
                    setData({ ...json, startDate: moment(json.startDate).format('YYYY-MM-DD'), expiryDate: moment(json.expiryDate).format('YYYY-MM-DD') });
                }, handleErrorResponse
            )
            .finally(() => {
                setIsLoading(false);
            });
    }

    function submit(e: any) {
        e.preventDefault();
        setIsSaving(true);

        return emailtemplateService
            .submit(data)
            .then(
                () => {
                    toastr.success("Saved successfully");
                    params.onSave();
                },
                (e: any) => toastr.error(e)
            )
            .finally(() => setIsSaving(false));
    }

    function disable() {
        if (!params.itemId) return;
        setIsLoading(true);
        return emailtemplateService
            .disable(params.itemId)
            .then(
                (d: any) => {
                    toastr.success("Disabled successfully");
                    fetchData();
                    params.onSave();
                }, handleErrorResponse
            )
            .finally(() => setIsLoading(false));
    }

    function handleChange(event: any) {
        setData((_data: any) => ({ ..._data, [event.target.name]: event.target.value }))
    };

    function handleTextareaChange(newContent: string) {
        setData((_data: any) => ({ ..._data, body: newContent }))
    };

    return (

        <Drawer
            anchor={"right"}
            variant="persistent"
            open={params.isOpen}
            ModalProps={{
                keepMounted: true
            }}>

            <div
                tabIndex={0}
                role="button">

                <div>

                    <DrawerHeader name={(!!params.itemId) ? "Update Email Template" : "Create Email Template"} onClose={params.onClose} />

                    <ValidatorForm
                        onSubmit={submit}
                        noValidate>

                        <Grid container spacing={1} sx={useDrawerStyles.container}>

                            <Grid item xs={12}>
                                {getEnumDropdown("Email Type", "emailTypeId", EmailTypeEnum, data["emailTypeId"], handleChange, true)}
                            </Grid>

                            <Grid item xs={12}>
                                <TextValidatorHcs
                                    key="name"
                                    name="name"
                                    label="Name"
                                    required
                                    fullWidth
                                    validators={['required', 'minStringLength:1']}
                                    errorMessages={['required field', "Field cannot be empty"]}
                                    value={data.name}
                                    onChange={handleChange}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <TextValidatorHcs
                                    key="subject"
                                    name="subject"
                                    label="Subject"
                                    required
                                    type="text"
                                    fullWidth
                                    validators={['required']}
                                    errorMessages={['required field']}
                                    value={data.subject}
                                    onChange={handleChange}
                                />
                            </Grid>

                            <Grid item xs={12}>
                                <TinyMce tagName="Body" value={data.body} onChange={handleTextareaChange} />
                            </Grid>

                        </Grid>

                        <Grid container spacing={1} sx={useDrawerStyles.container}>

                            <Grid item xs={(data.id === 0 ? 12 : 6)}>
                                <PrimaryButton
                                    isSaving={isSaving}
                                    isLoading={isLoading}
                                    type="submit"
                                    variant="save">{"Save"}
                                </PrimaryButton>
                            </Grid>

                            {data.id > 0 &&
                                <Grid item xs={6}>
                                    <PrimaryButton
                                        type="button"
                                        variant="danger"
                                        disabled={isLoading}
                                        onClick={disable}
                                        icon="block"
                                    >
                                        Disable
                                    </PrimaryButton>
                                </Grid>
                            }

                        </Grid>

                    </ValidatorForm>
                </div>
            </div>
        </Drawer >
    );
};